/*
  Ratings_v2.js propTypes
  extracted from https://bully---varnish.ref-sa-tech.io/documentation/resources/oaspec.json
  on 2019-04-15T15:32:06.065Z
*/

import { arrayOf, boolean, number, shape, string } from 'prop-types'

import { ReviewCustomer_v1 } from './ReviewCustomer_v1'
import { SellerReply_v1 } from './SellerReply_v1'

const Review_v1 = {
  active: boolean,
  activationDate: string,
  categoryCodes: arrayOf(string),
  customer: shape(ReviewCustomer_v1),
  language: string,
  message: string,
  premium: boolean,
  rating: number,
  reviewId: string,
  sellerReply: shape(SellerReply_v1),
  submissionDate: string,
  tenant: string,
  title: string,
  upid: string,
  variant_code: string,
  widget: boolean,
}

export default Review_v1
